<template>
  <div v-if="showFlyout"
       class="bx-normalize bx-typo--epg bx-epg-search bx-epg-search--autocomplete">
    <div v-if="hasChannels"
         class="bx-epg-search__autocomplete-channels">
      <span>
        <strong>Sender</strong>
      </span>
      <div v-for="channel in epgAutocompleteSearch.channels"
           :key="channel.originId"
           class="bx-epg-search__row">
        <Channel :channel="channel" />
      </div>
    </div>
    <div v-if="hasBroadcasts"
         class="bx-epg-search__autocomplete-broadcasts">
      <span>
        <strong>Sendungen</strong>
      </span>
      <div v-for="( broadcasts, date ) in epgAutocompleteSearch.broadcasts"
           :key="date">
        <span>
          {{ new Date(date).toLocaleDateString('de-DE', { weekday: 'long', day: '2-digit', month: '2-digit' }) }}
        </span>
        <div v-for="broadcast in broadcasts"
             :key="broadcast.originId"
             class="bx-epg-search__row">
          <Channel :channel="{...broadcast.channel, url: broadcast.url}" />
          <Broadcast :broadcast="broadcast" />
        </div>
      </div>
    </div>
    <span v-if="showNoResultsInfo || hasApiError"
          class="bx-typo--14px bx-typo--center">
      <p v-if="showNoResultsInfo && !hasApiError">
        <strong>Keine passenden Sender oder Sendungen gefunden.</strong><br>
        Probiere einen allgemeineren Suchbegriff.
      </p>
      <p v-if="hasApiError">
        <strong>Unsere Server brauchen kurz eine Pause…</strong><br>Bitte später nochmal versuchen.
      </p>
    </span>
  </div>
</template>

<script>
import Broadcast from './Broadcast.vue'
import Channel from './Channel.vue'

export default {
  components: {
    Channel,
    Broadcast
  },
  props: {
    searchPhrase: {
      type: String,
      default: ''
    },
    epgAutocompleteSearch: {
      type: Object,
      default: () => ({
        broadcasts: {},
        channels: []
      })
    },
    hasApiError: {
      type: Boolean,
      default: false
    },
    searchInProgress: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close-flyout'],
  data () {
    return {
      noResultsDelayTimeout: null,
      delayedShowNoResults: false,
      body: null
    }
  },
  computed: {
    showNoResultsInfo () {
      return this.delayedShowNoResults && !this.hasChannels && !this.hasBroadcasts && this.searchPhrase?.length > 2 && !this.searchInProgress
    },
    hasChannels () {
      return this.epgAutocompleteSearch?.channels.length
    },
    hasBroadcasts () {
      return Object.keys(this.epgAutocompleteSearch.broadcasts).length
    },
    showFlyout () {
      return this.hasChannels || this.hasBroadcasts || this.showNoResultsInfo
    }
  },
  watch: {
    showFlyout (newValue) {
      const viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      if (newValue && viewportWidth < 840) {
        this.body.classList.add('bx-js-dialog-opened')
      } else {
        this.body.classList.remove('bx-js-dialog-opened')
      }
    },
    searchPhrase () {
      clearTimeout(this.noResultsDelayTimeout)
      this.delayedShowNoResults = false
      this.noResultsDelayTimeout = setTimeout(() => {
        this.delayedShowNoResults = true
      }, 300) // Adjust delay as needed (e.g., 300ms)
    }
  },
  mounted () {
    this.body = document.body
    // Click outside of the flyout to close it
    document.addEventListener('click', this.closeFlyout)
  },
  beforeUnmount () {
    this.body.classList.remove('bx-js-dialog-opened')
    document.removeEventListener('click', this.closeFlyout)
  },
  methods: {
    closeFlyout (event) {
      const flyout = this.$el
      const epgTab = document.querySelector('button[data-search-type="epg"]')
      if (!flyout.contains(event.target) && !epgTab.contains(event.target)) {
        this.$emit('close-flyout')
      }
    }
  }
}
</script>
